module.exports = __webpack_public_path__ + "img/office6.a7db00ce.png";